import script from "./ComputeWizardSize.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardSize.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardSize.vue?vue&type=style&index=0&id=3e6d1cb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6d1cb2"]])

export default __exports__